import React from 'react';

export const initialModalOptions: ModalOptionsType = {
  type: null,
  showCloseIcon: true,
  disableEscExit: false,
  onRequestClose: (closeModal: () => void, data?: any) => closeModal(),
  hideOnRouteChange: true,
};

export type ModalOptionsType = {
  type?: string | null;
  showCloseIcon?: boolean;
  closeIconColor?: string;
  disableEscExit?: boolean;
  timeout?: number;
  onRequestClose?(closeModal: () => void, data?: any): void;
  hideOnRouteChange?: boolean;
};

const useModalState = () => {
  const [modal, setModal] = React.useState<boolean>(false);
  const [modalContent, setModalContent] = React.useState<any>(null);
  const [modalOptions, setModalOptions] = React.useState<ModalOptionsType>(initialModalOptions);

  const handleModal = (content, options: ModalOptionsType = {}) => {
    // set show/hide of modal - Changed to check existence of content as before calling showModal('MyContent') was actually a toggle
    setModal(!!content);

    if (content) {
      setModalContent(content);
    } else if (modalOptions?.onRequestClose) {
      modalOptions.onRequestClose(() => null);
    }

    // Think ...modalOptions should be removed otherwise we are merging in previous state regardless of site context
    if (options) {
      setModalOptions({ ...modalOptions, ...options });
    }
  };

  return [modal, handleModal, modalContent, modalOptions];
};

export default useModalState;
